import React from 'react';
import AppContainer from './components/App/AppContainer.jsx';
import ReactDOM from 'react-dom';

ReactDOM.render(
    <AppContainer/>,
    document.getElementById('root')
);